import React from 'react';
import { cx } from './formStyles';
import { CheckmarkIcon } from '../icons';

type FormCheckboxProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
  error?: string;
};

export function FormCheckbox({
  id,
  checked,
  onChange,
  children,
  error
}: FormCheckboxProps) {
  return (
    <div className="flex flex-col gap-[8px]">
      <label htmlFor={id} className="flex items-start gap-3 cursor-pointer">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <span
          aria-hidden
          className={cx(
            'mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-[6px] border transition',
            checked ? 'border-onboarding-card-green bg-onboarding-card-green' : 'border-[#a0978a]'
          )}
        >
          {checked && (
            <CheckmarkIcon className="h-3.5 w-3.5 text-white" />
          )}
        </span>
        <span className="text-[14px] leading-[1.6] text-black">
          {children}
        </span>
      </label>
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
